import React from "react";
import FullMenu from "../components/FullMenu";
import Hero from "../components/Hero";
import NavbarMenu from "../components/NavbarMenu";
const MenuScreen = () => {
    return (
        <>
            <NavbarMenu />

            <FullMenu />
        </>
    );
};

export default MenuScreen;
